<div class="skeleton-product-detail-summary-card">
  <div class="skeleton skeleton--heading"></div>

  <div class="skeleton-product-detail-summary-card__columns">
    <div class="skeleton-product-detail-summary-card__columns__left">
      <div class="skeleton skeleton--label"></div>
      <div class="skeleton skeleton--value"></div>

      <div class="skeleton skeleton--label"></div>
      <div class="skeleton skeleton--value"></div>

      <div class="skeleton skeleton--label"></div>
      <div class="skeleton skeleton--value"></div>
    </div>

    <div class="skeleton-product-detail-summary-card__columns__right">
      <div class="skeleton skeleton--label"></div>
      <div class="skeleton skeleton--value"></div>

      <div class="skeleton skeleton--label"></div>
      <div class="skeleton skeleton--value"></div>

      <div class="skeleton skeleton--label"></div>
      <div class="skeleton skeleton--value"></div>
    </div>
  </div>
</div>
